import type { NotificationEntity } from '../../../types/notification.types';
import { formatNotificationAge } from '../helpers/notificationFormat';
import {
  RowAge,
  RowBody,
  RowButton,
  RowText,
  RowTitle,
  RowTitleLine,
  UnreadDot,
  VisuallyHidden,
} from './NotificationRow.styled';

type Props = {
  notification: NotificationEntity;
  onOpen: (notification: NotificationEntity) => void;
  /** The dropdown's tighter line, rather than the page's card. */
  compact?: boolean;
};

/**
 * One notification: what happened, when, and whether it has been read.
 *
 * The title and body are the backend's own words for every type, known or
 * not - which is what lets a type this build has never heard of still show
 * up properly, just without anywhere to go.
 */
export const NotificationRow = ({ notification, onOpen, compact }: Props) => {
  const unread = !notification.seen;

  return (
    <RowButton
      type="button"
      $compact={compact}
      onClick={() => onOpen(notification)}
    >
      <UnreadDot $visible={unread} />
      <RowText>
        <RowTitleLine>
          <RowTitle $unread={unread}>
            {notification.title}
            {/* Said, not only shown: the dot and the weight are visual. */}
            {unread && <VisuallyHidden> (unread)</VisuallyHidden>}
          </RowTitle>
          <RowAge>{formatNotificationAge(notification.createdAt)}</RowAge>
        </RowTitleLine>
        <RowBody $clamp={compact ? 2 : undefined} $unread={unread}>
          {notification.body}
        </RowBody>
      </RowText>
    </RowButton>
  );
};
